import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TextInput } from '@molecules';
import { Icon, Button } from '@atoms';

const Wrapper = styled.span`
  margin-left: 15px;
`;
const TooltipWrapper = styled.div`
  top: 80px;
  position: absolute;
  background: white;
  width: 256px;
  min-width: 256px;
  border: none;
  border-radius: 0px;
  padding: 12px;
  z-index: 10;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
`;
const TooltipHeader = styled.div`
  color: #cccccc;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 10px;
`;
const SpeakersCount = styled.div`
  margin-top: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #808080;
`;

const ButtonWrapper = styled.div`
  margin-left: 50px;
  margin-top: 10px;
`;

export default class TranscriptSpeakersTooltip extends React.Component {
  speakers = {};
  state = {
    tooltipOpen: false,
  };

  componentDidMount() {
    this.props.speakers.forEach((speaker) => {
      this.speakers[speaker.id] = speaker.name;
    });
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { changeSpeakerNames, transcriptId } = this.props;
    changeSpeakerNames({ speakers: this.speakers, transcriptId });
    this.setState({ tooltipOpen: false });
  };

  toggleTooltip = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ tooltipOpen: !prevState.tooltipOpen }));
  };

  render() {
    const { speakers } = this.props;
    return (
      <Wrapper>
        <Button
          style={{ width: '42px', height: '42px', padding: '5px' }}
          onClick={this.toggleTooltip}
        >
          <Icon style={{ marginLeft: '2px' }} name="pencilGreyActive" />
        </Button>
        {this.state.tooltipOpen && (
          <TooltipWrapper>
            <form onSubmit={this.onSubmit}>
              <TooltipHeader>Edit information</TooltipHeader>
              {speakers.map((speaker) => (
                <TextInput
                  underlined
                  key={speaker.id}
                  onChange={(e) => {
                    this.speakers[speaker.id] = e.target.value;
                  }}
                  defaultValue={speaker.name}
                  label="Speaker name"
                />
              ))}
              <SpeakersCount>There are {speakers.length} speakers in total</SpeakersCount>
              <ButtonWrapper>
                <Button invisible type="button" onClick={this.toggleTooltip}>
                  Cancel
                </Button>
                <Button
                  style={{ width: '124px', marginLeft: '10px' }}
                  primary
                  type="submit"
                >
                  Submit
                </Button>
              </ButtonWrapper>
            </form>
          </TooltipWrapper>
        )}
      </Wrapper>
    );
  }
}
TranscriptSpeakersTooltip.propTypes = {
  speakers: PropTypes.array,
  transcriptId: PropTypes.number,
  changeSpeakerNames: PropTypes.func,
};
TranscriptSpeakersTooltip.defaultProps = {
  speakers: [],
};



// WEBPACK FOOTER //
// ./components/molecules/TranscriptSpeakersTooltip.js